import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/icons/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ICONS, permission: Permission.UPDATE }) ||
      !!context.userPermissions.isInternalRole;
    context.validatePermissions({ isAllowed, preload });
  },
});
